module.exports = __webpack_public_path__ + "components/copyright/static/copyright-5ce34f03f4486802acd7a6ab1c6c807f.svg";